import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { SortArrow } from "../../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const QuickSaleListTableHeader = ({
  isAscending = false,
  handleSort,
  isAscendingStatus = false,
  disabled = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className="invoiceListTableHeader">
      <Box
        onClick={
          disabled
            ? undefined
            : () => {
                triggerLogEvent(analytics, "quick_sale_sort", {
                  sort_field: "date",
                  is_ascending: !isAscending,
                });
                handleSort("date");
              }
        }
        className={`invListTableHeaderCol sevenColumn textLeft sidebarOption ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.date}
        >
          {I18n.date}
          <SortArrow
            id="quick_sale_date_sort"
            isAscending={!isAscending}
            disabled={disabled}
          />
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.contact}
        >
          {I18n.contact}{" "}
        </ParagraphText>
      </Box>
      <Box
        className={`invListTableHeaderCol sevenColumn textLeft cursorPointer`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.status}
        >
          {I18n.status}{" "}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.category}
        >
          {I18n.category}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.amount}
        >
          {I18n.amount}{" "}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.balance}
        >
          {I18n.balance}{" "}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn textCenter`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.actions}
        >
          {I18n.actions}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default QuickSaleListTableHeader;
